import { aboutMe } from "../assets/portfolioData";
import "../styles/About.css";

const homeUrl = window.location.href.includes("localhost")
  ? "http://localhost:3000/#/"
  : "https://pscott.io/#/";

const { emailLink, musicLink, resumeLink } = aboutMe;

export function About() {
  return (
    <div className="About">
      <div className="text-container">
        <h3>
          <em>
            <span className="highlight">tl;dr</span>
          </em>
        </h3>

        <p>
          My experience spans full-stack development, team leadership, system
          security, API integrations, performance tuning, data reconciliation,
          and leveraging cloud technologies to solve business problems.
        </p>

        <p>
          I'm a builder who unblocks and augments teams, and a teacher who turns
          complexity into clarity. Beyond code, I enjoy studying biblical
          literature,{" "}
          <a href={musicLink} target="_blank" rel="noreferrer noopener">
            <span className="highlight underline">playing piano</span>
          </a>
          , investing, and continual upskilling.
        </p>
        <p>
          Find my{" "}
          <a href={resumeLink} target="_blank" rel="noreferrer noopener">
            <span className="highlight underline">résumé</span>
          </a>{" "}
          here or{" "}
          <a href={`mailto:${emailLink}`}>
            {" "}
            <span className="highlight underline">say hello!</span>
          </a>
        </p>

        <p id="back-home">
          <a href={`${homeUrl}`}>&lt; back home</a>
        </p>
      </div>
    </div>
  );
}
